import React from 'react';
import { ButtonToolbar } from 'reactstrap';
import PropTypes from 'prop-types';
import PrintCargoTicketButton from '../../reservation/ticket/ticket-toolbar/PrintCargoTicketButton';
import DeliverInternalParcelButton from './DeliverInternalParcelButton';
import { CARGO_ITEM_STATUS } from '../../../../config/constants';
import ReturnInternalParcelButton from './ReturnInternalParcelButton';
import PrintExitGuideButton from './PrintExitGuideButton';
import EditInternalCargoItemButton from './EditInternalCargoItemButton';

const InternalParcelToolbar = ({ internalParcel }) => (
  <ButtonToolbar className="pull-right">
    <div>
      <PrintCargoTicketButton ticket={internalParcel} />{' '}
      {internalParcel.status !== CARGO_ITEM_STATUS.DELIVERED.value &&
        internalParcel.status !== CARGO_ITEM_STATUS.RETURNED.value && (
          <>
            <EditInternalCargoItemButton internalParcel={internalParcel} />{' '}
            <DeliverInternalParcelButton
              internalParcelId={internalParcel.id}
              internalParcel={internalParcel}
            />
          </>
        )}
      {internalParcel.district && (
        <PrintExitGuideButton internalParcel={internalParcel} />
      )}
      {internalParcel.status === CARGO_ITEM_STATUS.DELIVERED.value &&
        internalParcel.returnToAgency && (
          <ReturnInternalParcelButton internalParcelId={internalParcel.id} />
        )}
    </div>
  </ButtonToolbar>
);

InternalParcelToolbar.propTypes = {
  internalParcel: PropTypes.instanceOf(Object).isRequired,
};

export default InternalParcelToolbar;
